import { render, staticRenderFns } from "./TypeAmap.vue?vue&type=template&id=b22d9a7a&"
import script from "./TypeAmap.vue?vue&type=script&lang=js&"
export * from "./TypeAmap.vue?vue&type=script&lang=js&"
import style0 from "./TypeAmap.vue?vue&type=style&index=0&id=b22d9a7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports